<template>
    <div class="teamStatsSmall">
        <div class="statsCardLabel mb-4">
            <p class="stats-card-header">{{ translations.season }}</p>
            <div class="selectDiv">
                <select v-model="currentSeason" style="width: 100%; border-radius: 10px; padding: 8px 16px; border: 1px solid rgba(51, 51, 51, 0.25);">
                    <option v-for="(season) in possessionStats.seasons.teamStatistics" :value="season.id">
                        20{{ season.season.seasonYear.split("/")[0] }}/20{{ season.season.seasonYear.split("/")[1] }}
                    </option>
                </select>
            </div>
        </div>
      
            <div class="statsCard d-flex justify-content-between flex-wrap">
                <div class="stats-card-header">{{ translations.ball_possession }}</div>
                <div class="d-flex progressbar-small">
                    <div class="stats-card-header mr-3" :key="possession">{{ possession }}%</div>
                    <progress class="possession-progress" :value="possessionStats.seasons.teamStatistics[currentSeason].average_ball_possession.value" max="100"></progress>
                </div>
            </div>

    </div>
</template>

<script>

export default {
    name: 'possession-stats',
    props: {
        possessionStats: {
            type: Object,
            required: true,
        }, 
        translations: {
            type: Object,
            required: true,
        },

    },
    data: function () {
        return {
            currentSeason: this.possessionStats.seasons.currentSeason.id,
        }
       
    },
    
    computed: {
        possession() {
            return this.possessionStats.seasons.teamStatistics[this.currentSeason].average_ball_possession.value
        },

    },
}

</script>